import { BannerWithImage } from "./BannerWithImage";

export const UniversalRender = BannerWithImage;
